import { saveProperties } from '../effects/saveProperties';
import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    segmentTrackAction
} from '../../../../../../../../../middlewares/segment';
import { SegmentCardSourceValue } from '../../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import {
    ICustomPropertiesElement
} from '../../../../../../../base/components/CustomProperties/components/CustomProperty/types';

export const onSave = (
    boardId: TBoardId,
    elements: ICustomPropertiesElement[]
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.CUSTOM_PROPERTIES_EDIT_SAVE_CLICKED, {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardSourceValue.BOARD_SETTINGS
        }));
        return dispatch(saveProperties(boardId, elements));
    };
    return action;
};
